import React,{Component} from 'react';

import Social from './Social';

import './Navigation.less';

class Navigation extends Component{
  render(){
    const {goTo,menuItems,currentSection,data} = this.props;
    return (
        <div className="navigation">
          <div className='navigation-menu'></div>
          <div className='navigation-logo-container'>
            <img src="/img/logo.svg" className="navigation-logo" />
          </div>
          <div className='navigation-items'>
            {
              menuItems.map(item => {

                let href = '#';
                let active = false;

                if(item != 'Start'){
                  href += item;
                }

                if(currentSection == href){
                  active = true;
                }

                return <a key={href} href={href} className={active ? "active" : ""}  onClick={e => goTo(e)}>{item}</a>
              })
            }
          </div>
          <Social data={data} />
        </div>
    )
  }
}

export default Navigation



// WEBPACK FOOTER //
// ./src/components/Navigation.js